/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FamilyTypeDTO } from './FamilyTypeDTO';
import {
    FamilyTypeDTOFromJSON,
    FamilyTypeDTOFromJSONTyped,
    FamilyTypeDTOToJSON,
} from './FamilyTypeDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface FamilyTypePageDTO
 */
export interface FamilyTypePageDTO {
    /**
     * 
     * @type {Array<FamilyTypeDTO>}
     * @memberof FamilyTypePageDTO
     */
    content?: Array<FamilyTypeDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyTypePageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyTypePageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FamilyTypePageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof FamilyTypePageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof FamilyTypePageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof FamilyTypePageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof FamilyTypePageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof FamilyTypePageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof FamilyTypePageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the FamilyTypePageDTO interface.
 */
export function instanceOfFamilyTypePageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FamilyTypePageDTOFromJSON(json: any): FamilyTypePageDTO {
    return FamilyTypePageDTOFromJSONTyped(json, false);
}

export function FamilyTypePageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyTypePageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(FamilyTypeDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function FamilyTypePageDTOToJSON(value?: FamilyTypePageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(FamilyTypeDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

